import { defaultOrdersFilters, IPillFilter, IPropertyFilter, useStore } from "../store";
import { IDateRange } from "../contracts";

export interface IExternalOrdersRedirectionFilters {
  orderCreationRange?: IDateRange;
  requestedDeliveryRange?: IDateRange;
  confirmedDeliveryRange?: IDateRange;
  calculatedConfirmRange?: IDateRange;
  status?: number;
  meetRequested?: IPillFilter[];
  opCos?: string[];
  onTime?: IPillFilter[];
  property?: IPropertyFilter;
}

export const useOrdersFiltersActions = () => {
  const [_, setState] = useStore();

  const setOrdersCreationRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      ordersCommonFilters: { ...old.ordersCommonFilters, orderCreationRange: range }
    }));
  };

  const setOrdersRequestedDeliveryRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      ordersCommonFilters: { ...old.ordersCommonFilters, requestedDeliveryRange: range }
    }));
  };

  const setOrdersConfirmedDeliveryRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      ordersCommonFilters: { ...old.ordersCommonFilters, confirmedDeliveryRange: range }
    }));
  };

  const setOrdersPlannedDeliveryRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      ordersCommonFilters: { ...old.ordersCommonFilters, plannedDeliveryRange: range }
    }));
  };

  const setOrdersPoCalculatedConfirmRange = (range: IDateRange) => {
    setState(old => ({
      ...old,
      ordersCommonFilters: { ...old.ordersCommonFilters, poCalculatedConfirmRange: range }
    }));
  };
  const setOrdersStatus = (status: number) => {
    const newStatus = (old: number[], status: number) => {
      if (old.includes(status)) {
        return old.filter(s => s !== status);
      } else {
        return [...old, status];
      }
    };

    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        statuses: newStatus(old.ordersCommonFilters.statuses || [], status)
      }
    }));
  };

  const setOrdersMeetRequested = (filter: IPillFilter[]) => {
    setState(old => ({
      ...old,
      ordersCommonFilters: { ...old.ordersCommonFilters, meetRequested: filter }
    }));
  };

  const setOrdersOnTime = (filter: IPillFilter[]) => {
    setState(old => ({
      ...old,
      ordersCommonFilters: { ...old.ordersCommonFilters, onTime: filter }
    }));
  };

  const setOrdersOpCo = (opCo: string[]) => {
    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        opCos: opCo.length ? opCo : undefined
      }
    }));
  };

  const setOrdersRedirectionFilters = (filters: IExternalOrdersRedirectionFilters) => {
    const {
      orderCreationRange,
      requestedDeliveryRange,
      confirmedDeliveryRange,
      calculatedConfirmRange,
      status,
      meetRequested,
      opCos,
      onTime
    } = filters;

    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        orderCreationRange: orderCreationRange,
        requestedDeliveryRange,
        confirmedDeliveryRange,
        calculatedConfirmRange,
        statuses: status === undefined ? undefined : [status],
        meetRequested: meetRequested || defaultOrdersFilters.meetRequested,
        onTime: onTime || defaultOrdersFilters.onTime,
        opCos: opCos ? opCos : undefined
      }
    }));
  };

  const clearOrdersRequestedDeliveryRange = () => {
    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        requestedDeliveryRange: undefined
      }
    }));
  };

  const clearOrdersConfirmedDeliveryRange = () => {
    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        confirmedDeliveryRange: undefined
      }
    }));
  };

  const clearOrdersPlannedDeliveryRange = () => {
    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        plannedDeliveryRange: undefined
      }
    }));
  };

  const clearOrdersPoCalculatedConfirmRange = () => {
    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        poCalculatedConfirmRange: undefined
      }
    }));
  };

  const clearOrdersStatus = () => {
    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        statuses: undefined
      }
    }));
  };

  const clearOrdersMeetRequested = () => {
    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        meetRequested: defaultOrdersFilters.meetRequested
      }
    }));
  };

  const clearOrdersOnTime = () => {
    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        onTime: defaultOrdersFilters.onTime
      }
    }));
  };

  const clearOrdersOpCo = () => {
    setState(old => ({
      ...old,
      ordersCommonFilters: {
        ...old.ordersCommonFilters,
        opCos: undefined
      }
    }));
  };

  return {
    setOrdersCreationRange,
    setOrdersRequestedDeliveryRange,
    setOrdersConfirmedDeliveryRange,
    setOrdersPlannedDeliveryRange,
    setOrdersPoCalculatedConfirmRange,
    setOrdersStatus,
    setOrdersMeetRequested,
    setOrdersOnTime,
    setOrdersOpCo,
    setOrdersRedirectionFilters,
    clearOrdersRequestedDeliveryRange,
    clearOrdersConfirmedDeliveryRange,
    clearOrdersPlannedDeliveryRange,
    clearOrdersPoCalculatedConfirmRange,
    clearOrdersStatus,
    clearOrdersMeetRequested,
    clearOrdersOnTime,
    clearOrdersOpCo
  };
};
